module.exports = __webpack_public_path__ + "img/img6.e823ea61.svg";